import Home from './Home';
import AboutWilt from './AboutWilt';
import Managing from './Managing';
import AboutUs from './AboutUs';
import Disclaimer from './Disclaimer';

export default [
    Home,
    AboutWilt,
    Managing,
    AboutUs,
    Disclaimer
];
